<div class="rd" [class.rd--zoom]="zoom">
  <header class="rd-bar">
    <a class="rd-back" [routerLink]="landingPath(slug)" aria-label="Back to the guide page">‹ <span class="rd-hide-sm">Guide page</span></a>
    <span class="rd-title">{{ manifest?.title || 'Market Guides' }}</span>
    <div class="rd-tools" *ngIf="state === 'ready'">
      <button type="button" class="rd-tool" (click)="contentsOpen = !contentsOpen" [attr.aria-expanded]="contentsOpen" *ngIf="contents.length">
        Contents
      </button>
      <button type="button" class="rd-tool" (click)="toggleZoom()" [attr.aria-pressed]="zoom">
        {{ zoom ? 'Fit page' : 'Zoom' }}
      </button>
    </div>
  </header>

  <ng-container [ngSwitch]="state">
    <main *ngSwitchCase="'ready'" class="rd-stage" (touchstart)="touchStart($event)" (touchend)="touchEnd($event)">
      <div class="rd-pages" [class.rd-pages--spread]="visible.length > 1">
        <figure class="rd-page" *ngFor="let n of visible" [style.aspectRatio]="ratio(n)">
          <img *ngIf="src(n) as u; else loadingPage" [src]="u" [alt]="'Page ' + n" draggable="false" (contextmenu)="$event.preventDefault()" />
          <ng-template #loadingPage><span class="rd-page-loading">Loading page {{ n }}…</span></ng-template>
          <figcaption class="rd-sr">{{ text(n) }}</figcaption>
        </figure>
      </div>
      <button type="button" class="rd-edge rd-edge--prev" (click)="prev()" [disabled]="atStart" aria-label="Previous page"></button>
      <button type="button" class="rd-edge rd-edge--next" (click)="next()" [disabled]="atEnd" aria-label="Next page"></button>
    </main>

    <div *ngSwitchCase="'signin'" class="rd-msg">
      <h1>Sign in to read this guide</h1>
      <p>The full guide is available in your PlateX account once you have claimed it.</p>
      <div class="rd-msg-actions">
        <button type="button" class="rd-btn" (click)="signIn()">Sign in</button>
        <a [routerLink]="landingPath(slug)">About the guide</a>
      </div>
    </div>
    <div *ngSwitchCase="'denied'" class="rd-msg">
      <h1>This guide is not in your account yet</h1>
      <p>Visit the guide page to add it to your PlateX account.</p>
      <div class="rd-msg-actions">
        <a class="rd-btn" [routerLink]="landingPath(slug)">Go to the guide page</a>
      </div>
    </div>
    <div *ngSwitchCase="'error'" class="rd-msg">
      <h1>The guide could not be loaded</h1>
      <p>Please refresh the page or try again shortly.</p>
    </div>
    <div *ngSwitchDefault class="rd-msg" aria-live="polite"><p>Opening the guide…</p></div>
  </ng-container>

  <footer class="rd-nav" *ngIf="state === 'ready'">
    <button type="button" class="rd-arrow" (click)="prev()" [disabled]="atStart" aria-label="Previous page">‹</button>
    <span class="rd-count" aria-live="polite">{{ label }}</span>
    <button type="button" class="rd-arrow" (click)="next()" [disabled]="atEnd" aria-label="Next page">›</button>
  </footer>

  <aside class="rd-contents" *ngIf="contentsOpen" role="dialog" aria-label="Contents">
    <div class="rd-contents-head">
      <span>Contents</span>
      <button type="button" class="rd-tool" (click)="contentsOpen = false" aria-label="Close contents">✕</button>
    </div>
    <ol>
      <li><button type="button" (click)="jump(1)"><span>Cover</span><span>1</span></button></li>
      <li *ngFor="let c of contents">
        <button type="button" (click)="jump(c.page)"><span>{{ c.title }}</span><span>{{ c.page }}</span></button>
      </li>
    </ol>
  </aside>
</div>
